import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const SegmentedTab = ({ options = [], active, onChange, iconClassName }) => {
  return (
    <div className="segmented-tab">
      {options.map((item) => (
        <div
          key={item.value}
          className={active === item.value ? 'tab-item active' : 'tab-item'}
          onClick={() => onChange(item.value)}>
          <span className={iconClassName}>{item.icon}</span>

          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

SegmentedTab.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node,
      icon: PropTypes.node
    })
  ),
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  iconClassName: PropTypes.string
};

export default SegmentedTab;
